import { Redirect } from 'react-router-dom';
import createPersistedState from 'use-persisted-state';
import { Chains } from 'api/types/httpsTypes/d-wallets';

const lastVisitedAddressKey = `last-address-trading-terminal`;
export const useLastVisitedAddress = createPersistedState<string>(
  lastVisitedAddressKey
);
const lastVisitedChain = `last-chain-trading-terminal`;
export const useLastVisitedChain =
  createPersistedState<string>(lastVisitedChain);

export const defaultChain = Chains.Solana;
export const defaultContract = '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R';

const SnipeContainer = () => {
  const [address] = useLastVisitedAddress(defaultContract);
  const [chain] = useLastVisitedChain(defaultChain);

  return <Redirect to={`/dex/snipe/new/${chain}/${address}`} />;
};

export default SnipeContainer;
